import userActions from "../actions/userActions";
import authActions from "../actions/authActions";
import { authService } from "../../services/authService";
import { locale } from "devextreme/localization";

export function userLogin(username, password, stayLoggedIn) {
  return (dispatch) => {
    dispatch(userActions.loginPending());

    authService.login(username, password).then((user) => {
      if (!!user) {
        localStorage.setItem("user", JSON.stringify(user));

        return dispatch(userActions.loginSuccess(user));
      } else {
        return dispatch(userActions.loginError("Wrong username/password"));
      }
    });
  };
}

export function userLogout() {
  return (dispatch) => {
    localStorage.removeItem("user");
    sessionStorage.removeItem("user");
    dispatch(userActions.logout());
  };
}

export function userChangeLanguage(lang) {
  return (dispatch) => {
    localStorage.setItem("lang", lang);
    locale(lang);

    dispatch(authActions.changeLanguage(lang));
  };
}
